import responsiveSize from 'helper/responsiveSize'
import { RefObject } from 'react'
import styled from 'styled-components'
import { Theme } from 'styles/Themes'

interface IStyleProps {
  disabled?: boolean
  ref?: (
    _instance: HTMLDivElement | null
  ) => void | RefObject<HTMLDivElement> | null
  isDragging?: boolean
  color: string
  nameSize?: string
}

interface ITagProps {
  background?: string
  color?: string
}

interface Alert {
  onTrash?: any
}

export const Trashcan = styled.img`
  position: absolute;
  top: 18px;
  right: 20px;
  height: 16px;
  width: 16px;
  cursor: pointer;
`

export const KanbanCard = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 142px;
  box-sizing: border-box;
  padding: 10px;
  /* gap: ${responsiveSize.responsiveWidth(
    Theme.sizes.KANBAN.GAP.SECONDARY
  )}; */
  /* box-sizing: border-box; */
  line-height: 16px;
  user-select: none;
  width: 210px;
  border-radius: 5px;

  color: ${(props: IStyleProps) => {
    return props.color || '#eeeeee'
  }};
  background: #f9f9f9;
  border: 1px solid #eeeeee;
  box-shadow: 0px 0px 8px 0px rgba(0, 0, 0, 0.16);
  .kc-name {
    color: #1c1d22;
    font-family: ${Theme.fontFamily.SECONDARY};
    font-size: 12px;
    font-weight: 400;
    width: ${(props: any) => {
      if (props.nameSize === 'small') return '55%'
      if (props.nameSize === 'medium') return '85%'
      return '100%'
    }};

    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }

  .kc-tags-container {
    display: flex;
    height: auto;
    flex-wrap: wrap;
    margin-top: 8px;
    margin-bottom: 10px;
    gap: 6px;
  }

  .trash-row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
    width: 100%;
  }

  .trashcan {
    position: absolute;
    top: 10px;
    right: 10px;
    height: 18px;
    width: 18px;
    cursor: pointer;
  }

  .kc-specialist {
    display: flex;
    justify-content: flex-start;
    align-items: center;
    max-width: 100%;
    box-sizing: border-box;
    height: 26px;
    padding: 0 10px;
    border-radius: 5px;
    color: ${Theme.pallete.PRIMARY};
    font-family: ${Theme.fontFamily.SECONDARY};
    font-size: 12px;
    font-style: normal;
    font-weight: 400;
    line-height: 14px;
    background: ${Theme.pallete.SECONDARY};
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25);

    .kc-icon {
      max-width: 16px;
      max-height: 16px;
      margin-right: 8px;
    }

    .kc-picture {
      width: 16px;
      height: 16px;
      margin-right: 8px;
      border-radius: 50%;
      object-fit: cover;
    }

    .kc-span {
      max-width: 150px;
      max-height: 150px;
      color: ${Theme.pallete.PRIMARY};
      font-family: ${Theme.fontFamily.SECONDARY};
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
      line-height: 14px;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }

  /* Tooltip container */
  .tooltip {
    position: relative;
    display: inline-block;
    /* border-bottom: 1px dotted black; If you want dots under the hoverable text */
  }

  /* Tooltip container */
  .tooltip2 {
    position: relative;
    display: inline-block;
    /* border-bottom: 1px dotted black; If you want dots under the hoverable text */
  }

  /* Tooltip text */
  .tooltip .tooltiptext {
    visibility: hidden;
    /* width: 120px; */
    background-color: black;
    color: #fff;
    text-align: center;
    padding: 10px;
    border-radius: 3px;
    font-size: 13px;
    opacity: 0.8;
    /* Position the tooltip text - see examples below! */
    position: absolute;
    z-index: 5;

    bottom: 100%;
    left: 0;
  }

  .tooltip2 .tooltiptext2 {
    visibility: hidden;
    /* width: 120px; */
    background-color: black;
    color: #fff;
    text-align: center;
    padding: 10px;
    border-radius: 3px;
    font-size: 13px;
    opacity: 0.8;
    /* Position the tooltip text - see examples below! */
    position: absolute;
    z-index: 5;

    top: 100%;
    left: 0;
  }

  /* Show the tooltip text when you mouse over the tooltip container */
  .tooltip:hover .tooltiptext {
    visibility: visible;
  }

  .tooltip .tooltiptext::after {
    content: ' ';
    position: absolute;
    top: 100%; /* At the bottom of the tooltip */
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: black transparent transparent transparent;
  }

  .tooltip2:hover .tooltiptext2 {
    visibility: visible;
  }

  .tooltip2 .tooltiptext2::after {
    content: ' ';
    position: absolute;
    bottom: 100%; /* At the bottom of the tooltip */
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: transparent transparent black transparent;
  }
`

export const Tag = styled.span`
  text-align: center;
  width: auto;
  height: auto;
  max-width: 80%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  border-radius: 5px;
  font-size: 10px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  letter-spacing: 0.1px;
  padding: 2px 6px;
  color: ${(props: ITagProps) => {
    return props.color || `${Theme.pallete.SECONDARY}`
  }};
  background: ${(props: ITagProps) => {
    return props.background || `${Theme.pallete.QUINARY}`
  }};
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.16);
`

export const AlertTags = styled.div`
  position: absolute;
  top: 16px;
  right: ${(props: Alert) => {
    if (props.onTrash) return '40px'
    return '14px'
  }};
`

export const YellowTag = styled(Tag)`
  background: #1c1d22;
  margin-right: 3px;
  color: white;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.16);
`

export const CopyLink = styled.div`
  cursor: pointer;
  width: 90%;
  height: 24px;
  border-radius: 5px;
  background-color: ${Theme.pallete.TERTIARY};
  display: flex;
  justify-content: flex-start;
  align-items: center;
  position: absolute;
  padding: 0 5px;
  box-sizing: border-box;
  top: 57px;
  left: 10px;

  .link-copy-text {
    color: white;
    margin-left: 8px;
    font-size: 12px;
  }

  .link-copy-icon {
    height: 16px;
    width: 16px;
    filter: invert(100%) sepia(1%) saturate(0%) hue-rotate(265deg)
      brightness(104%) contrast(104%);
  }
`
